import React, {useState,useEffect} from 'react';
import {Redirect,Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import FormControl from '@mui/material/FormControl';
import Badge from '@mui/material/Badge';
import Button from '@mui/material/Button';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import HelpIcon from '@mui/icons-material/Help';
import {Inc,Dataset,Owner,Item,ItemSearchCondition} from './Inc';
import {Tools} from './Tools';
import Ajax from './Ajax';
import Loading from './Loading';
import ItemListSearch from './ItemListSearch';
import ItemCheckTable from './ItemCheckTable';
import LetterConfirm from './LetterConfirm';
import LetterDownload from './LetterDownload';
import LetterFree from './LetterFree';
import Title from './Title';
import Toast from './Toast';
import AppBank from './AppBank';

interface LetterListProps {
	owner:Owner,
	bank:AppBank,
}
// let p:number = 1;
// let pages:Dataset[] = [];

const LetterList = (props:LetterListProps)=> {
    Ajax.setEditorId( props.owner.owner_id );
    const classes = useStyles();
	const defItems:Item[] = [];
	const defCheckedIds:number[] = [];
	const defCheckedItems:Item[] = [];
	const defValues:number[] = [];

	const [states,setStates] = useState({
		items:defItems,
		checkedIds:defCheckedIds,
		checkedItems:defCheckedItems,
		values:defValues,
		isLoading:true,
		isFinished:false,
		sheetId:0,
		modalPage:"",
		toast:"",
		currentPage:1,
		pages:[] as Dataset[],
		pager:null,
        cond:Inc.defaultItemSearchCondition(),
    });
    const search = (cond:ItemSearchCondition,page:number)=>{
		//console.log("search");
		//setStates({...states,"isLoading":true});
		window.scrollTo(0,0);
        Ajax.search("item/list",cond,page,(res:any)=>{
            //console.log(res);
            if( res.ok ){
                setStates(prev=>({...prev,items:res.items,cond:cond,currentPage:page,pager:res.pager,isLoading:false}));
            } else {
                setStates(prev=>({...prev,"isLoading":false}));
            }
        });
	}
	const jump = (to:number)=>{
		//send(values,p);
		//p = to;
		search(states.cond,to);
	}
	const check = (e: React.MouseEvent<HTMLElement>)=>{
        if( !e.currentTarget.dataset.index ){
			return;
		}
		const item = states.items[parseInt(e.currentTarget.dataset.index)];
		if( !states.checkedIds.includes(item.item_id) ){
			setStates(prev=>({...prev,"checkedItems":prev.checkedItems.concat(item),"checkedIds":prev.checkedIds.concat(item.item_id)}));
		}
	}
	const uncheck = (e: React.MouseEvent<HTMLElement>)=>{
        if( !e.currentTarget.dataset.index ){
			return;
		}
		const item = states.items[parseInt(e.currentTarget.dataset.index)];
		if( states.checkedIds.includes(item.item_id) ){
			let ids = states.checkedIds;
			const index1 = ids.findIndex((v) => v===item.item_id);
			ids.splice(index1,1);

			let items = states.checkedItems;
			const index2 = items.findIndex((v) => v.item_id===item.item_id);
			items.splice(index2,1);

			setStates(prev=>({...prev,"checkedItems":items,"checkedIds":ids}));
		}
	}
	const isChecked = (id:number)=>{
		return states.checkedIds.includes(id);
	}
	const confirm = ()=>{
		setStates(prev=>({...prev,"modalPage":"confirm"}));
	}
	const next = (items:Item[],values:number[],flag:boolean)=>{
		setStates(prev=>({...prev,"modalPage":"","isLoading":true}));
		let list:Dataset[] = [];
		for( let i=0 ; i<items.length ; i++ ){
			list.push( {
				id: String(items[i].item_id),
				label: String(values[i]),
			})
		}
		//console.log("list",list);
		Ajax.send("letter/entry",{items:list},(res:any)=>{
			//console.log( res );
			if( res.ok ){
				let page = "download";
				if( flag===false ){
					page = "free"
				}
				setStates(prev=>({...prev,"modalPage":page,"sheetId":res.sheet_id,"values":values,"isLoading":false}));
			} else {
				setStates(prev=>({...prev,"isLoading":false,"toast":"error"}));
			}
		})
	}
	const closeToast = ()=>{
		setStates(prev=>({...prev,"toast":""}));
	}
	const closeModal = ()=>{
		if( states.modalPage==="download" || states.modalPage==="free" ){
			setStates(prev=>({...prev,"modalPage":"","checkedItems":defItems,"checkedIds":defCheckedIds,"values":defValues,isFinished:true}));
		} else {
			setStates(prev=>({...prev,"modalPage":""}));
		}
	}
	useEffect( ()=>{
		Ajax.send("item/pages",{},(res:any)=>{
			if( res.ok ){
				setStates(prev=>({...prev,pages:res.pages}));
			}
		});
	},[]);

	if( states.isFinished ){
		return <Redirect to='/consign'/>
	}

	if( props.owner.owner_id===0 ){
		return <Redirect to="/profile"/>
	}

	return (
		<div id="item_list" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={8} lg={9}>
                    <Paper className={classes.paper}>
                        <Title text="納品書作成" icon="cart"/>
                        <div style={{marginBottom:"2em"}}>
							架空ストアに商品を送る際に同封する「納品書（商品委託書）」を作成します。<br/>
							商品リストから納品したい商品を全て選んでから、「商品の確認」をクリックして下さい。（複数選択可）<br/>
							<Hidden mdUp implementation="js">
								<Grid container spacing={1} style={{marginTop:"1em"}}>
									<Grid item xs={6}><Button variant="text" color="primary" component={Link} to='/first/p3' startIcon={<HelpIcon/>}>納品のハウツー</Button></Grid>
									<Grid item xs={6}>
									<div style={{textAlign:'right'}}>
										<Badge color="success" badgeContent={states.checkedIds.length}><Button variant="contained" color="primary" onClick={confirm} disabled={states.checkedIds.length===0} style={{width:"100%"}}><ShoppingCartIcon/>商品の確認</Button></Badge>
									</div>
									</Grid>
								</Grid>
							</Hidden>
                        </div>

						<ItemCheckTable items={states.items} owner={props.owner} check={check} uncheck={uncheck} isChecked={isChecked}/>

						<div style={{padding:"1em"}}>
						{Tools.pager(states.pager,jump)}
						</div>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
					<Hidden mdDown implementation="js">
						<Paper className={classes.paper} style={{marginBottom:"1em"}}>
							<Title text="商品を選んだら" size={2}/>
							<FormControl fullWidth={true}>
								<Badge color="success" badgeContent={states.checkedIds.length}><Button variant="contained" color="primary" style={{width:"100%"}} onClick={confirm} disabled={states.checkedIds.length===0}>
									<ShoppingCartIcon/>商品の確認
								</Button></Badge>
							</FormControl>
							<div style={{textAlign:'right'}}>
								<Button variant="text" color="primary" component={Link} to='/first/p3' startIcon={<ArrowForwardIcon/>}>納品のハウツー</Button>
								<Button variant="text" color="primary" component={Link} to='/consign' startIcon={<ArrowForwardIcon/>}>一覧にもどる</Button>
							</div>
						</Paper>
					</Hidden>
	
                    <Paper className={classes.paper}>
                        <ItemListSearch pages={states.pages} update={search} bank={props.bank} bankKey={"savedLetterListItemSearchCondition"}/>
                    </Paper>
                </Grid>
            </Grid>

            <Loading isLoading={states.isLoading}/>
			<Toast mes={states.toast} close={closeToast}/>
			<LetterConfirm next={next} close={closeModal} isOpen={states.modalPage==="confirm"} items={states.checkedItems} owner={props.owner}/>
			<LetterDownload close={closeModal} isOpen={states.modalPage==="download"} owner={props.owner} sheetId={states.sheetId}/>
			<LetterFree close={closeModal} owner={props.owner} isOpen={states.modalPage==="free"} sheetId={states.sheetId} items={states.checkedItems} values={states.values}/>
		</div>
	);
}

export default LetterList;
